module.exports = __webpack_public_path__ + "img/DASH.d3ca5186.png";